import { handleActions } from 'redux-actions';

import localize from '../../../localization/container';
import * as apiActions from '../actions';

const defaultState = {
  error: '',
  users:{},
  dashboard:{}
};

export const login = handleActions(
  {
    [apiActions.loginSuccess]: (state, action) => {
      if (action.payload.user === false) {
        return {
          ...state,
          error: localize({
            id: 'error.wrongEmailPassword',
            defaultMessage: 'Invalid email address or password'
          })
        };
      } else {
        return {
          ...state,
          error: ''
        };
      }
    },
    [apiActions.initalDataSuccess]: (state, action) => ({
      ...state,
      dashboard: action.payload
    }),
    [apiActions.piechartBulkSuccess]: (state, action) => ({
      ...state,
      piechartBulk: action.payload
    }),
     [apiActions.trendchartBulkSuccess]: (state, action) => ({
      ...state,
      trendchartBulk: action.payload
    }),
    [apiActions.loginFail]: (state, action) => ({
      ...state,
      error: localize({
        id: 'error.wrongEmailPassword',
        defaultMessage: 'Invalid email address or password'
      })
    }),
    [apiActions.clearLogin]: (state, action) => ({
      ...state,
      error: ''
    })
  },
  defaultState
);
